import React, { Component } from "react";
import { Route, Switch, HashRouter, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";

import Login from "../containers/LoginContainer";

import DefaultLayout from "../containers/DefaultLayout";
import ResetPassword from "../containers/ResetPasswordContainer";
import ForgotPassword from "../containers/ForgotPassword";
// import MeterWiseConsumption from "../screens/MeterConsumptionData/index";
import Suspended from "../screens/Suspended";
import PaymentExpired from "../screens/PaymentExpired";
import TermsAndConditions from "../screens/TermsAndConditions";
import PrivacyPolicy from "../screens/PrivacyPolicy";
import RefundPolicy from "../screens/RefundPolicy";
import ContactUs from "../screens/ContactUs";

var history = createBrowserHistory();
// const Login = React.lazy(() => import('../components/Pages/Login'));
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem("fmsToken") ? (
        <Component {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

function AppNavigator() {
  return (
    <HashRouter basename="/">
      <React.Suspense>
        <Switch>
          <Route
            exact
            path="/login"
            name="Login Page"
            render={(props) => <Login {...props} />}
          />
          <Route path="/resetpassword" name="reset" component={ResetPassword} />
          {/* <Route
            path="/meterWiseConsumption"
            name="MeterWiseConsumption"
            component={MeterWiseConsumption}
          /> */}
          <Route
            path="/forgotpassword"
            name="ForgotPassword"
            component={ForgotPassword}
          />
          <Route path="/suspended" name="Suspended" component={Suspended} />
          <Route
            path="/paymentExpired"
            name="PaymentExpired"
            component={PaymentExpired}
          />
          <Route
            path="/termsandconditions"
            name="TermsAndConditions"
            component={TermsAndConditions}
          />
          <Route
            path="/privacypolicy"
            name="PrivacyPolicy"
            component={PrivacyPolicy}
          />
          <Route
            path="/refundpolicy"
            name="RefundPolicy"
            component={RefundPolicy}
          />
          <Route path="/contactus" name="ContactUs" component={ContactUs} />
          <Route
            path="/"
            name="Home"
            render={(props) => <DefaultLayout {...props} />}
          />
        </Switch>
      </React.Suspense>
    </HashRouter>
  );
}
export default AppNavigator;
